/** Etiquetas y tipo de control según formato PDF (infantil / escolar) */

export const TIPO_CAMPO = {
  LINEA: "linea",
  MULTILINEA: "multilinea",
  FECHA: "fecha",
};

export const CAMPOS_DATOS_GENERALES = [
  { key: "nombreApellido", label: "Nombre y apellido", tipo: TIPO_CAMPO.LINEA, maxLength: 80 },
  { key: "cedula", label: "Cédula", tipo: TIPO_CAMPO.LINEA, maxLength: 20 },
  { key: "fnacimiento", label: "Fecha de nacimiento", tipo: TIPO_CAMPO.FECHA },
  { key: "edadTexto", label: "Edad", tipo: TIPO_CAMPO.LINEA, maxLength: 25 },
  { key: "domicilio", label: "Domicilio actual", tipo: TIPO_CAMPO.LINEA, maxLength: 120 },
  { key: "sexo", label: "Sexo", tipo: TIPO_CAMPO.LINEA, maxLength: 15 },
  { key: "diagnostico", label: "Diagnóstico", tipo: TIPO_CAMPO.LINEA, maxLength: 100 },
  { key: "referidoPor", label: "Referido por", tipo: TIPO_CAMPO.LINEA, maxLength: 80 },
  { key: "colegio", label: "Colegio", tipo: TIPO_CAMPO.LINEA, maxLength: 80, soloInfantil: true },
  { key: "escuela", label: "Escuela", tipo: TIPO_CAMPO.LINEA, maxLength: 80, soloEscolar: true },
  { key: "gradoEscolar", label: "Grado escolar actual", tipo: TIPO_CAMPO.LINEA, maxLength: 40 },
  { key: "medicamentos", label: "Medicamentos", tipo: TIPO_CAMPO.LINEA, maxLength: 80 },
  { key: "alergias", label: "Alergias", tipo: TIPO_CAMPO.LINEA, maxLength: 80 },
  { key: "nombreMadre", label: "Nombre de la madre", tipo: TIPO_CAMPO.LINEA, maxLength: 80 },
  { key: "nombrePadre", label: "Nombre del padre", tipo: TIPO_CAMPO.LINEA, maxLength: 80 },
  { key: "fechaInforme", label: "Fecha de informe", tipo: TIPO_CAMPO.FECHA },
  { key: "fechaInicioTerapia", label: "Fecha de inicio de terapia", tipo: TIPO_CAMPO.FECHA },
];

export const CAMPOS_MOTIVO = [
  { key: "motivoMenor", label: "Nombre del menor", tipo: TIPO_CAMPO.LINEA, maxLength: 60 },
  { key: "motivoAcompanante", label: "Acompañante (ej. madre)", tipo: TIPO_CAMPO.LINEA, maxLength: 50 },
  { key: "motivoReferido", label: "Referido por (motivo)", tipo: TIPO_CAMPO.LINEA, maxLength: 80 },
];

export const CAMPOS_TEXTO_LARGO = [
  { key: "perfilOcupacional", label: "Perfil ocupacional", rows: 5 },
  { key: "objetivo", label: "Objetivo", rows: 4 },
  { key: "organizacionComportamiento", label: "Organización del comportamiento", rows: 4 },
  { key: "sensorial", label: "E. Procesamiento sensorial", rows: 4 },
  { key: "comunicacion", label: "F. Habilidades de comunicación e interacción", rows: 4 },
  { key: "evaluaciones", label: "G. Evaluaciones y resultados", rows: 3 },
  { key: "impresionOcupacional", label: "Impresión ocupacional", rows: 5 },
  { key: "objetivosTrimestre", label: "Objetivos a lograr en el trimestre", rows: 5 },
  { key: "recomendaciones", label: "Recomendaciones", rows: 5 },
];

export const CAMPOS_ABVD = [
  { key: "alimentacion", label: "Alimentación", tipo: TIPO_CAMPO.LINEA, maxLength: 200 },
  { key: "vestido", label: "Vestido", tipo: TIPO_CAMPO.LINEA, maxLength: 200 },
  { key: "controlEsfinter", label: "Control de esfínter", tipo: TIPO_CAMPO.LINEA, maxLength: 200 },
  { key: "higiene", label: "Higiene personal", tipo: TIPO_CAMPO.LINEA, maxLength: 200 },
  {
    key: "descansoSueno",
    label: "Descanso y sueño",
    tipo: TIPO_CAMPO.MULTILINEA,
    rows: 3,
    maxLength: 500,
  },
];

export const CAMPOS_AIVD_BASE = [
  { key: "tareasCasa", label: "Tareas en casa", tipo: TIPO_CAMPO.MULTILINEA, rows: 3, maxLength: 500 },
  { key: "pantallas", label: "Uso de pantallas", tipo: TIPO_CAMPO.MULTILINEA, rows: 3, maxLength: 500 },
];

export const CAMPOS_AIVD_ESCOLAR = [
  { key: "dinero", label: "Manejo de dinero", tipo: TIPO_CAMPO.MULTILINEA, rows: 3, maxLength: 500 },
  { key: "cuidadoOtros", label: "Cuidado de otros", tipo: TIPO_CAMPO.MULTILINEA, rows: 3, maxLength: 500 },
  {
    key: "tiempoPlanificacion",
    label: "Manejo del tiempo y planificación",
    tipo: TIPO_CAMPO.MULTILINEA,
    rows: 3,
    maxLength: 500,
  },
  {
    key: "transporte",
    label: "Transporte y movilidad",
    tipo: TIPO_CAMPO.MULTILINEA,
    rows: 3,
    maxLength: 500,
  },
];

export const CAMPOS_MOTOR = [
  { key: "gruesas", label: "Habilidades motoras gruesas", tipo: TIPO_CAMPO.LINEA, maxLength: 250 },
  { key: "finas", label: "Habilidades motoras finas", tipo: TIPO_CAMPO.LINEA, maxLength: 250 },
  {
    key: "observacionesPosturales",
    label: "Observaciones posturales",
    tipo: TIPO_CAMPO.LINEA,
    maxLength: 250,
  },
  { key: "lateralidad", label: "Lateralidad", tipo: TIPO_CAMPO.LINEA, maxLength: 120 },
];

export const CAMPOS_COGNITIVO = [
  { key: "percepcionVisual", label: "Percepción visual", tipo: TIPO_CAMPO.MULTILINEA, rows: 2, maxLength: 400 },
  {
    key: "funcionesEjecutivas",
    label: "Funciones ejecutivas",
    tipo: TIPO_CAMPO.MULTILINEA,
    rows: 2,
    maxLength: 400,
  },
  { key: "atencion", label: "Atención y concentración", tipo: TIPO_CAMPO.MULTILINEA, rows: 2, maxLength: 400 },
  { key: "memoria", label: "Memoria", tipo: TIPO_CAMPO.MULTILINEA, rows: 2, maxLength: 400 },
  {
    key: "procesamientoEspacial",
    label: "Procesamiento espacial",
    tipo: TIPO_CAMPO.MULTILINEA,
    rows: 2,
    maxLength: 400,
  },
];

export const CAMPOS_FIRMAS = [
  { key: "firmaTerapeuta", label: "Lic. Terapeuta ocupacional", tipo: TIPO_CAMPO.LINEA, maxLength: 60 },
  { key: "firmaPadre", label: "Firma del padre de familia", tipo: TIPO_CAMPO.LINEA, maxLength: 60 },
];

export const filtrarCamposGenerales = (escolar) =>
  CAMPOS_DATOS_GENERALES.filter((c) => {
    if (c.soloInfantil && escolar) return false;
    if (c.soloEscolar && !escolar) return false;
    return true;
  });
